import axios from 'axios';
import ReactGA from 'react-ga4';
import Slider from 'react-slick';
import ReactPlayer from 'react-player';
import { NavLink } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import '../styles/product.scss';
import '../styles/top.scss';

const Top = () => {
    
    return (
        <div className='page-container main-bg'>
            <div className="top-hero">
                <div className="top-info">
                    <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="LOGO" className="logo" />
                    <h2>Coming Early 2026</h2>
                    <div className="mobile-captcha">
                        <h4 className="top-captcha_2">
                            Even Hell Can't Stop Her!
                        </h4>
                        <h4 className="top-captcha">
                            Even Hell Can't Stop Her!
                        </h4>
                        <h4 className="top-captcha">
                            Even Hell Can't Stop Her!
                        </h4>
                        <h4 className="top-captcha">
                            Even Hell Can't Stop Her!
                        </h4>
                        <h4 className="top-captcha">
                            Even Hell Can't Stop Her!
                        </h4>
                        <h4 className="top-captcha">
                            Even Hell Can't Stop Her!
                        </h4>
                    </div>
                </div>
                <h4 className="top-captcha_2">
                    Even Hell Can't Stop Her!
                </h4>
                <h4 className="top-captcha">
                    Even Hell Can't Stop Her!
                </h4>
                <h4 className="top-captcha">
                    Even Hell Can't Stop Her!
                </h4>
                <h4 className="top-captcha">
                    Even Hell Can't Stop Her!
                </h4>
                <h4 className="top-captcha">
                    Even Hell Can't Stop Her!
                </h4>
                <h4 className="top-captcha">
                    Even Hell Can't Stop Her!
                </h4>
            </div>
            <nav className="top-navigation">
                <h3 className="nav-link"
                    onClick={()=>{
                        window.scrollTo(0,0)
                    }}
                >
                    TOP
                </h3>
                <a href="#story" className="nav-link">STORY</a>
                <a href="#system" className='nav-link'>SYSTEM</a>
                <a href="#character" className="nav-link">CHARACTER</a>
                {
                    /*
                        <a href="#product" className='nav-link'>PRODUCT</a>
                    */
                }
            </nav>
            <Trailers/>
            <Story/>
            <System/>
            <Character/>
            {
                /*
                    <Product/>
                */
            }
            <Spec/>
        </div>
    )
}

const Trailers = () => {

    const TrailerList = [
        '_tbshWzk10c'
    ]

    let sliderRef = useRef(null);
    const next = () => {
        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };
    
    const settings = {
        className: "center variable-width",
        centerMode: true,
        centerPadding: '0px',
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        dots: true,
        appendDots: dots => (
            <div className="custom-slider_nav"style={{ textAlign: "center" }}>
                <button className="custom-slider_button custom-slider_prev" onClick={previous}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/prev.png`} alt="" />
                </button>
                <div className="custom-slider_dots">
                    {dots}
                </div>
                <button className="custom-slider_button custom-slider_next" onClick={next}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/next.png`} alt="" />
                </button>
            </div>
        ),
        customPaging: i => (
            <button className={`custom-slider_pagination`}>
                    
            </button>
        )
    };

    return (
        <>
            <div className="title-wrapper" style={{marginTop: '50px'}}>
                <div className="title-character">
                    <img src={`${process.env.PUBLIC_URL}/img/ttl_chara01.png`} alt="" />
                </div>
                <img src={`${process.env.PUBLIC_URL}/img/ttl_movie.png`} alt="" className="image-title" />
            </div>
            <div className="frame">
                <div className="slider-container"
                    style={{paddingBottom: '35px'}}
                >
                    <Slider
                        ref={slider => {
                            sliderRef = slider;
                        }}
                        {...settings}
                    >
                        {
                            TrailerList.map((trailer, i)=>(
                                <div className="trailer-thumb_wrapper" key={i}>
                                    <div className="video-container">
                                        <div className="video-wrapper">
                                            <ReactPlayer
                                                className='react-player'
                                                src={`https://www.youtube.com/watch?v=${trailer}`}
                                                autoPlay
                                                muted
                                                loop
                                                width='100%'
                                                height='100%'
                                                onError={(error) => {
                                                    console.error('ReactPlayer error:', error)
                                                }}
                                                style={{ marginBottom: '15px' , aspectRatio: '16 / 9'}}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </Slider>
                </div>
            </div>
            <div id="story"></div>
        </>
    )
}

const Story = () => {

    let sliderRef = useRef(null);
    const next = () => {
        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };
    
    const settings = {
        className: "center",
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        dots: true,
        appendDots: dots => (
            <div className="custom-slider_nav"style={{ textAlign: "center" }}>
                <button className="custom-slider_button custom-slider_prev" onClick={previous}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/prev.png`} alt="" />
                </button>
                <div className="custom-slider_dots">
                    {dots}
                </div>
                <button className="custom-slider_button custom-slider_next" onClick={next}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/next.png`} alt="" />
                </button>
            </div>
        ),
        customPaging: i => (
            <button className={`custom-slider_pagination`}>
                    
            </button>
        )
    };
    
    return (
        <div className="frame"
            style={{
                padding: '50px 2.5vw'
            }}
        >
            <div className="title-wrapper">
                <div className="title-character">
                    <img src={`${process.env.PUBLIC_URL}/img/ttl_chara03.png`} alt="" />
                </div>
                <img src={`${process.env.PUBLIC_URL}/img/ttl_story.png`} alt="" className="image-title" />
            </div>
            <div className="section-accent">
                <span className='gold-gradient'>
                    "Cast me into hell, if you will! Come what may, I shall prevail!"<br/>
                </span>
                <span className='gold-gradient smaller'>
                    Live out a sweets-filled life in hell as a villainess who never wavers.
                </span>
            </div>
            <div className="slider-container screenshot-slider_container"
                style={{marginTop: '50px'}}
            >
                <Slider
                    ref={slider => {
                        sliderRef = slider;
                    }}
                    {...settings}
                >
                    <div className='screenshot-slider_wrapper'>
                        <img src={`${process.env.PUBLIC_URL}/img/ss/story_still01.webp`} alt="" className="slider-screenshot" />
                    </div>
                    <div className='screenshot-slider_wrapper'>
                        <img src={`${process.env.PUBLIC_URL}/img/ss/story_still02.webp`} alt="" className="slider-screenshot" />
                    </div>
                    <div className='screenshot-slider_wrapper'>
                        <img src={`${process.env.PUBLIC_URL}/img/ss/story_still03.webp`} alt="" className="slider-screenshot" />
                    </div>
                    <div className='screenshot-slider_wrapper'>
                        <img src={`${process.env.PUBLIC_URL}/img/ss/story_still04.webp`} alt="" className="slider-screenshot" />
                    </div>
                    <div className='screenshot-slider_wrapper'>
                        <img src={`${process.env.PUBLIC_URL}/img/ss/story_still05.webp`} alt="" className="slider-screenshot" />
                    </div>
                </Slider>
            </div>
            <p className="body-text" style={{marginTop: '50px'}}>
                Lady Étrange von Rosenburg is framed and executed for an assassination attempt on the royal family. When she awakens, she finds herself...in <span>hell</span>. Yet she remains unfazed, brushing off demons that would attempt to persecute her—for she is <span>"a most fearsome villainess"</span> capable of wielding the dark arts. <br/><br/>
                
                Through her overwhelming power and charisma, Étrange quickly finds herself amassing followers loyal to her and her cause. One after another, she is confronted by not only the denizens of hell, but people with ties to her previous life as well.<br/><br/>
                
                Will Étrange be able to find happiness in hell? And will she discover the real truth behind her execution?<br/><br/>
                
                <span>The curtain rises on the adventures of a most gorgeous and elegant villainess.</span>
            </p>
            <div id="system"></div>
        </div>
    )
}

const System = () => {

    const [hasMounted, setHasMounted] = useState(false);

    const [refButtonSystem, inViewButtonSystem, entryButtonSystem] = useInView({
        threshold: 0.01
    }); 

    useEffect(() => {
        setHasMounted(true);
    }, []);

    return (
        <div className="frame"
            style={{
                padding: '50px 2.5vw'
            }}
        >
            <div className="title-wrapper">
                <div className="title-character">
                    <img src={`${process.env.PUBLIC_URL}/img/ttl_chara04.png`} alt="" />
                </div>
                <img src={`${process.env.PUBLIC_URL}/img/ttl_system.png`} alt="" className="image-title" />
            </div>
            <div className="top-system_visual">
                <img src={`${process.env.PUBLIC_URL}/img/top-system_etrange.png`} alt="" className="top-system_etrange" />
                <div className="top-system_text body-text">
                    <p
                        style={{maxWidth: '600px'}}
                    >
                        Embark on a thrilling action adventure and rise to power alongside Étrange—a villainess cast into hell.
                    </p>
                    <span className="gold-block">
                        Recruit allies and bring enemies
                    </span> <br/>
                    <span className="magenta-block">
                        to heel in your conquest of hell!
                    </span>
                </div>
            </div>
            <div className="body-video"
                style={{marginBottom: '30px', position: 'relative'}}
            >
                {
                    hasMounted && (
                        <ReactPlayer
                            className='react-player'
                            src={`${process.env.PUBLIC_URL}/img/video/battle.mp4`}
                            autoPlay
                            muted
                            loop
                            width='100%'
                            height='100%'
                            onError={(error) => {
                                console.error('ReactPlayer error:', error)
                            }}
                            style={{ marginBottom: '15px' }}
                        />
                    )
                }
                <img src={`${process.env.PUBLIC_URL}/img/footer/rp.svg`} alt='esrb rating' style={{width: '200px', position: 'absolute', top: '10px', right: '10px'}}/>
            </div>
            <NavLink to="/system">
                <button 
                    className={`main-button ${inViewButtonSystem && 'fade-in'}`}
                    ref={refButtonSystem}
                >
                    For more System Information
                </button>
            </NavLink>
            <div id="character"></div>
        </div>
    )
}

const Character = () => {

    let sliderRef = useRef(null);
    const next = () => {
        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };
    
    const settings = {
        className: "center variable-width",
        centerMode: true,
        infinite: true,
        variableWidth: true,
        speed: 1000,
        slidesToShow: 1,
        dots: true,
        appendDots: dots => (
            <div className="custom-slider_nav"style={{ textAlign: "center" }}>
                <button className="custom-slider_button custom-slider_prev" onClick={previous}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/prev.png`} alt="" />
                </button>
                <div className="custom-slider_dots character-dots">
                    {dots}
                </div>
                <button className="custom-slider_button custom-slider_next" onClick={next}>
                    <img src={`${process.env.PUBLIC_URL}/img/ui/next.png`} alt="" />
                </button>
            </div>
        ),
        customPaging: i => (
            <button className={`custom-slider_pagination`}>
                    
            </button>
        )
    };

    const characterList = [
        {
            image: 'etrange',
            name: "Étrange"
        },
        {
            image: 'cat-smith',
            name: "Cat-Smìth"
        },
        {
            image: 'cackie',
            name: "Cackie"
        },
        {
            image: 'chuckie',
            name: "Chuckie"
        },
        {
            image: 'chortie',
            name: "Chortie"
        },
        {
            image: 'sweetia',
            name: "Sweetia"
        },
        {
            image: 'erit',
            name: "Erit"
        },
        {
            image: 'schwartz',
            name: "Schwartz"
        },
        {
            image: 'ignacio',
            name: "Ignacio"
        },
        {
            image: 'kera',
            name: "Kera"
        },
        {
            image: 'bera',
            name: "Bera"
        },
        {
            image: 'rosa',
            name: "Rosa"
        },
        {
            image: 'aria',
            name: "Aria"
        },
        {
            image: 'overlord-doomaz',
            name: <><span className='gold-gradient'>Overlord</span><br/><span className='gold-gradient'>Doomaz</span></>
        },
        {
            image: 'jewel',
            name: "Jewel"
        },
        {
            image: 'crown-prince',
            name: "Crown Prince"
        },
        {
            image: 'angelina',
            name: "Angelina"
        },
    ]

    const [refButtonCharacter, inViewButtonCharacter, entryButtonCharacter] = useInView({
        threshold: 0.01
    }); 


    return(
        <>
            <div className="title-wrapper">
                <div className="title-character">
                    <img src={`${process.env.PUBLIC_URL}/img/ttl_chara05.png`} alt="" />
                </div>
                <img src={`${process.env.PUBLIC_URL}/img/ttl_character.png`} alt="" className="image-title" />
            </div>
            <div className="frame">
                <div className="slider-container">
                    <Slider
                        ref={slider => {
                            sliderRef = slider;
                        }}
                        {...settings}
                    >
                        {
                            characterList.map((char, i) => (
                                <NavLink to={`/character?char=${char.image}`} className={'badge-link'}>
                                    <div className="character-badge">
                                        <h3 className='gold-gradient'>{char.name}</h3>
                                        <img src={`${process.env.PUBLIC_URL}/img/character/${char.image}.webp`} alt="" className="character-icon" />
                                    </div>
                                </NavLink>
                            ))
                        }
                    </Slider>
                </div>
                <NavLink to='/character'>
                    <button 
                        className={`main-button ${inViewButtonCharacter && 'fade-in'}`}
                        ref={refButtonCharacter}
                        style={{marginTop: '60px'}}
                    >
                        For more Character Information
                    </button>
                </NavLink>
            </div>
            <div id="product"></div>
        </>
    )
}

const Product = ({ language }) => {
    const [platform, setPlatform] = useState('Nintendo Switch™')
    // Set default region based on language
    const [region, setRegion] = useState(language === 'FR' ? 'EU' : 'NA')
    const [data, setData] = useState(null)

    const [limitedLinks, setLimitedLinks] = useState([])
    const [digitalLinks, setDigitalLinks] = useState([])
    
    const [ref, inView, entry] = useInView({
        threshold: 1
    });

    // Content based on language
    const content = {
        ENG: {
            title: 'Products',
            selectPlatform: 'Select a platform:',
            choosePlatform: 'Choose platform',
            selectRegion: 'Select a region:',
            chooseRegion: 'Choose region',
            digitalEdition: 'Digital Edition',
            comingSoon: 'Coming Soon',
        },
        FR: {
            title: 'Produits',
            selectPlatform: 'Sélectionnez une plateforme',
            choosePlatform: 'plateforme',
            selectRegion: 'Sélectionnez une région',
            chooseRegion: 'région',
            digitalEdition: 'Édition numérique',
            comingSoon: 'Coming Soon',
        },
    }

    const text = content["ENG"];

    useEffect(() => {
        setRegion(language === 'FR' ? 'EU' : 'NA')
    }, [language])

    useEffect(() => {
        // Function to fetch data
        const fetchData = async () => {
            try {
                const response = await axios.get('https://nisamerica.com/api/game/etrange-overlord')
                if (response.data.game) {
                    setData(response.data.game.retailerLinks)
                }
                console.log(response.data.game.retailerLinks)
            } catch (error) {
                console.error('Error fetching data:', error)
            }
        }

        // Call the fetchData function
        fetchData()
    }, [])

    useEffect(() => {
        data &&
            setDigitalLinks(
                data.filter(
                    (product, index) =>
                        platform === product.platform &&
                        // product.region === region &&
                        product.edition === 'Digital Edition'
                )
            )
    }, [region, platform, data])

    return (
            <div className="product-wrapper">
                <div className="title-wrapper">
                    <div className="title-character">
                        <img src={`${process.env.PUBLIC_URL}/img/ttl_chara06.png`} alt="" />
                    </div>
                    <img src={`${process.env.PUBLIC_URL}/img/ttl_product.png`} alt="" className="image-title" />
                </div>
                <div className="line-title">
                    <div className="line-before">

                    </div>
                    <h3>Select a Platform:</h3>
                    <div className="line-after">

                    </div>
                </div>
                <div className="platform-list">
                    <button
                        className={
                            `platform-button ${platform==='Nintendo Switch™' && "platform-active"}`
                        }
                        onClick={()=> setPlatform("Nintendo Switch™")}
                    >
                        Nintendo Switch™
                    </button>
                    <button
                        className={
                            `platform-button ${platform==='PlayStation®4' && "platform-active"}`
                        }
                        onClick={()=> setPlatform("PlayStation®4")}
                    >
                        PlayStation®4
                    </button>
                    <button
                        className={
                            `platform-button ${platform==='PlayStation®5' && "platform-active"}`
                        }
                        onClick={()=> setPlatform("PlayStation®5")}
                    >
                        PlayStation®5
                    </button>
                    <button
                        className={
                            `platform-button ${platform==='PC' && "platform-active"}`
                        }
                        onClick={()=> setPlatform("PC")}
                    >
                        PC
                    </button>
                </div>
                {
                    platform !== 'PC' && <>
                        <div className="line-title">
                            <div className="line-before">

                            </div>
                            <h3>Select a Region:</h3>
                            <div className="line-after">

                            </div>
                        </div>
                        <div className="region-list">
                            <button className={`main-button fade-in`} ref={ref}
                                onClick={()=>setRegion("NA")}
                            >
                                NA
                            </button>
                            <button className={`main-button fade-in`}
                                onClick={()=>setRegion("EU")}
                            >
                                EU
                            </button>
                        </div>
                    </>
                }
                {
                    <>
                        <div className='product-section' style={{ paddingBottom: '40px' }}>
                            <div className='product-pair reverse' style={{ flexDirection: 'column' }}>
                                {platform === 'PC' && (
                                    <>
                                        <iframe
                                            title='STEAM Widget'
                                            src='https://store.steampowered.com/widget/3812660/'
                                            frameBorder='0'
                                            style={{
                                                maxWidth: '900px',
                                                width: '95vw',
                                                marginTop: '50px'
                                            }}
                                            width='100%'
                                            height='190'
                                            onClick={() => {
                                                ReactGA.event({
                                                    category: `Product - PC - Steam`,
                                                    action: `Product - PC - Steam`,
                                                    label: `Product - PC - Steam`,
                                                })
                                            }}
                                        ></iframe>
                                    </>
                                )}
                                {
                                    platform!== 'PC' && <>
                                        <img 
                                            src={
                                                `${process.env.PUBLIC_URL}/img/products/de-${
                                                    platform === "Nintendo Switch™" ? "nsw" :
                                                    platform === "PlayStation®5" ? "ps5" :
                                                    "ps4"
                                                }${region==="EU" ? "EU" : ''}.webp`
                                            } 
                                            alt="" className="product-glam"
                                        />
                                        <div className="product-link_list">
                                            <div className="product-link_list">
                                                <button className="product-button coming-soon">
                                                    Coming Soon
                                                </button>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </>
                }
            </div>
    )
}


const Spec = () => (
    <div className="spec-container">
        <div className="title-wrapper">
            <div className="title-character">
                <img src={`${process.env.PUBLIC_URL}/img/ttl_chara02.png`} alt="" />
            </div>
            <img src={`${process.env.PUBLIC_URL}/img/ttl_spec.png`} alt="" className="image-title" />
        </div>
        <table>
            <tbody>
                <tr>
                    <th>Title</th>	
                    <th>Etrange Overlord</th>
                </tr>
                <tr>
                    <th>
                        Release
                    </th>
                    <th>
                        Coming Early 2026
                    </th>
                </tr>   
                <tr>
                    <th>
                        Platforms
                    </th>
                    <th>
                        Nintendo Switch™, PS4®, PS5®, PC (Steam)
                    </th>
                </tr>
                <tr>
                    <th>
                        Genre
                    </th>
                    <th>
                        Action RPG
                    </th>
                </tr>
                <tr>
                    <th>
                        Players
                    </th>
                    <th>
                        1 (multiplayer feature up to 4)
                    </th>
                </tr>    
                <tr>
                    <th>
                        Text Languages
                    </th>
                    <th>
                        Console: English, French <br/>
                        PC: English, French, Japanese
                    </th>
                </tr>
                <tr>
                    <th>
                        Audio Languages
                    </th>
                    <th>
                        Japanese
                    </th>
                </tr>
                <tr>
                    <th>
                        Developer
                    </th>
                    <th>
                        <span>SuperNiche LLC</span><br/>
                        <span>BROCCOLI Co</span><br/>
                        <span>Gemdrops, Inc.</span>
                    </th>
                </tr>
            </tbody>
        </table>
    </div>
)
export default Top;
